import { scale, verticalScale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  skeletonParent: { marginHorizontal: scale(16), marginVertical: verticalScale(16), width: '80%' },
});
export default styles;
